import Content from "./Content";
import { IWizardStep } from "../../../../wizard/types";
import validator from "../../validators/step4/validator";

export const createConfigStep4: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add course",
  },
  content: Content,
  validator: validator,
  stepName: "step4",
};
